import React from "react";
import { Box, Typography } from "@mui/material";
import { connect } from "react-redux";
import Avatar from "../shared/components/Avatar";

const ServerMembersPanel = ({ selectedServer, onlineUsers }) => {
  if (!selectedServer) {
    return null;
  }

  const isOnline = (userId) => onlineUsers.some((user) => user.userId === userId);

  return (
    <Box
      sx={{
        width: "240px",
        height: "calc(100% - 48px)",
        mt: "48px",
        bgcolor: "#17181b",
        borderLeft: "1px solid #111214",
        boxSizing: "border-box",
        p: "14px 10px",
        overflowY: "auto",
      }}
    >
      <Typography sx={{ color: "#8e9297", fontSize: "12px", fontWeight: 800, textTransform: "uppercase", mb: 1 }}>
        Участники - {selectedServer.members?.length || 0}
      </Typography>
      {(selectedServer.members || []).map((member) => (
        <Box
          key={member._id}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            height: "42px",
            color: "#b9bbbe",
            borderRadius: "4px",
            px: "6px",
            "&:hover": { bgcolor: "#2b2d33", color: "#fff" },
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Avatar small username={member.username} displayName={member.displayName} avatarUrl={member.avatarUrl} />
            <Box
              sx={{
                position: "absolute",
                right: -2,
                bottom: -2,
                width: 9,
                height: 9,
                borderRadius: "50%",
                bgcolor: isOnline(member._id) ? "#23a55a" : "#80848e",
                border: "2px solid #17181b",
              }}
            />
          </Box>
          <Typography sx={{ fontSize: "14px", fontWeight: 700 }} noWrap>
            {member.displayName || member.username}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

const mapStoreStateToProps = ({ room, friends }) => ({
  selectedServer: room.selectedServer,
  onlineUsers: friends.onlineUsers || [],
});

export default connect(mapStoreStateToProps)(ServerMembersPanel);
